




// import React from "react";
// import CvInfo from "./CvInfo";
// import CvEducation from "./CvEducation";
// import CvWorkExperience from "./CvWorkExperience";
// import CvCertificate from "./CvCertificate";
// import CvGuarantor from "./CvGuarantor";
// import { useSelector } from "react-redux";
// import PDFGenerator from "./pdf/PDFGenerator";
// import { FaUser, FaGraduationCap, FaBriefcase, FaCertificate, FaUserShield } from 'react-icons/fa';

// function CvTemplate1({ education, experience, certificate, guarantor }) {
//   const loggedInUser = useSelector((state) => state.user);
  
//   return (
//     <PDFGenerator>
//       <div className="bg-gradient-to-b from-orange-50 to-orange-100 min-h-[297mm] w-full max-w-[210mm] mx-auto p-4 sm:p-6 lg:p-8 shadow-lg">
        
//         {/* Header Section */}
//         <div className="border-b border-orange-200 pb-4">
//           <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
//             <div>
//               <h1 className="text-2xl sm:text-3xl font-bold text-orange-800 leading-tight">
//                 {`${loggedInUser?.currentUser?.firstName} ${loggedInUser?.currentUser?.lastName}`}
//               </h1>
//               <p className="text-orange-600 mt-1 text-sm sm:text-base">Professional CV</p>
//             </div>
//             <div className="text-left sm:text-right">
//               <button className="px-4 py-2 rounded-lg bg-orange-600 text-white hover:bg-orange-700 transition-colors text-sm whitespace-nowrap">
//                 e-verify log
//               </button>
//               <p className="text-xs sm:text-sm text-orange-600 mt-2">Verified Professional Profile</p>
//             </div>
//           </div>
//         </div>

//         {/* Personal Information Section */}
//         <div className="mt-8">
//           <div className="flex items-center gap-2 mb-4">
//             <FaUser className="text-orange-600 flex-shrink-0" />
//             <h2 className="text-lg sm:text-xl font-semibold text-gray-800">Personal Information</h2>
//           </div>
//           <div className="bg-white rounded-lg p-4 sm:p-6 shadow-sm">
//             <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//               <CvInfo title="Date of Birth" data={loggedInUser?.currentUser?.dateOfBirth} />
//               <CvInfo title="Email" data={loggedInUser?.currentUser?.email} />
//               <CvInfo title="Address" data={loggedInUser?.currentUser?.address} />
//             </div>
//           </div>
//         </div>

//         {/* Education Section */}
//         <div className="mt-8">
//           <div className="flex items-center gap-2 mb-4">
//             <FaGraduationCap className="text-orange-600 flex-shrink-0" />
//             <h2 className="text-lg sm:text-xl font-semibold text-gray-800">Education Background</h2>
//           </div>
//           <div className="space-y-4">
//             {education && education?.map((eachEducation, index) => (
//               <div key={index} className="bg-white rounded-lg p-4 sm:p-6 shadow-sm">
//                 <CvEducation
//                   school={eachEducation?.school}
//                   course={eachEducation?.course}
//                   year={`${eachEducation?.startYear} - ${eachEducation?.finishYear}`}
//                 />
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Work Experience Section */}
//         <div className="mt-8">
//           <div className="flex items-center gap-2 mb-4">
//             <FaBriefcase className="text-orange-600 flex-shrink-0" />
//             <h2 className="text-lg sm:text-xl font-semibold text-gray-800">Work Experience</h2>
//           </div>
//           <div className="space-y-4">
//             {experience && experience?.map((eachExperience, index) => (
//               <div key={index} className="bg-white rounded-lg p-4 sm:p-6 shadow-sm">
//                 <CvWorkExperience
//                   title={eachExperience?.positionHeld}
//                   companyName={eachExperience?.companyName}
//                   year={`${eachExperience?.startYear} - ${eachExperience?.finishYear}`}
//                   jobDescription={eachExperience?.jobDescription}
//                 />
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Certificates Section */}
//         <div className="mt-8">
//           <div className="flex items-center gap-2 mb-4">
//             <FaCertificate className="text-orange-600 flex-shrink-0" />
//             <h2 className="text-lg sm:text-xl font-semibold text-gray-800">Certificates</h2>
//           </div>
//           <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//             {certificate && certificate?.map((eachCertificate, index) => (
//               <div key={index} className="bg-white rounded-lg p-4 sm:p-6 shadow-sm">
//                 <CvCertificate
//                   title={eachCertificate?.certificateName}
//                   year={eachCertificate?.issueDate}
//                   serialNumber={eachCertificate?.serialNumber}
//                   issueDate={eachCertificate?.issueDate}
//                 />
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* Guarantor Section */}
//         <div className="mt-8">
//           <div className="flex items-center gap-2 mb-4">
//             <FaUserShield className="text-orange-600 flex-shrink-0" />
//             <h2 className="text-lg sm:text-xl font-semibold text-gray-800">Guarantor</h2>
//           </div>
//           <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//             {guarantor && guarantor?.map((eachGuarantor, index) => (
//               <div key={index} className="bg-white rounded-lg p-4 sm:p-6 shadow-sm">
//                 <CvGuarantor
//                   guarantorName={eachGuarantor?.name}
//                   phoneNumber={eachGuarantor?.phone}
//                 />
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </PDFGenerator>
//   );
// }

// export default CvTemplate1;


import React, { useState, useEffect } from "react";
import CvInfo from "./CvInfo";
import CvEducation from "./CvEducation";
import CvWorkExperience from "./CvWorkExperience";
import CvCertificate from "./CvCertificate";
import CvGuarantor from "./CvGuarantor";
import { useSelector } from "react-redux";
import PDFGenerator from "./pdf/PDFGenerator";
import { FaUser, FaGraduationCap, FaBriefcase, FaCertificate, FaUserShield, FaEdit, FaSave } from 'react-icons/fa';

function CvTemplate1({ education, experience, certificate, guarantor }) {
  const loggedInUser = useSelector((state) => state.user);

  // Local editable state
  const [isEditing, setIsEditing] = useState(false);
  const [editableData, setEditableData] = useState({
    personalInfo: {
      firstName: loggedInUser?.currentUser?.firstName || '',
      lastName: loggedInUser?.currentUser?.lastName || '',
      dateOfBirth: loggedInUser?.currentUser?.dateOfBirth || '',
      email: loggedInUser?.currentUser?.email || '',
      address: loggedInUser?.currentUser?.address || '',
    },
    education: education || [],
    experience: experience || [],
    certificate: certificate || [],
    guarantor: guarantor || [],
  });

  // Sync props with local state when they change
  useEffect(() => {
    setEditableData({
      personalInfo: {
        firstName: loggedInUser?.currentUser?.firstName || '',
        lastName: loggedInUser?.currentUser?.lastName || '',
        dateOfBirth: loggedInUser?.currentUser?.dateOfBirth || '',
        email: loggedInUser?.currentUser?.email || '',
        address: loggedInUser?.currentUser?.address || '',
      },
      education: education || [],
      experience: experience || [],
      certificate: certificate || [],
      guarantor: guarantor || [],
    });
  }, [loggedInUser, education, experience, certificate, guarantor]);

  // Handle Personal Information changes
  const handlePersonalChange = (field, value) => {
    setEditableData(prev => ({
      ...prev,
      personalInfo: {
        ...prev.personalInfo,
        [field]: value
      }
    }));
  };

  // Handle changes in array sections (education, experience, etc.)
  const handleArrayChange = (section, index, field, value) => {
    setEditableData(prev => {
      const newArray = [...prev[section]];
      newArray[index] = { ...newArray[index], [field]: value };
      return { ...prev, [section]: newArray };
    });
  };

  const toggleEdit = () => {
    if (isEditing) {
      // Save logic can be expanded here (e.g., dispatch to Redux)
      console.log("CV Changes Saved:", editableData);
    }
    setIsEditing(!isEditing);
  };

  return (
    <PDFGenerator>
      <div className="bg-gradient-to-b from-orange-50 to-orange-100 min-h-[297mm] w-full max-w-[210mm] mx-auto p-4 sm:p-6 lg:p-8 shadow-lg relative">

        {/* Floating Edit/Save Button */}
        <button
          onClick={toggleEdit}
          className="absolute top-6 right-6 px-5 py-2.5 rounded-xl bg-orange-600 hover:bg-orange-700 text-white flex items-center gap-2 text-sm font-medium transition-all shadow-md z-20"
        >
          {isEditing ? (
            <>
              <FaSave className="text-lg" /> Save Changes
            </>
          ) : (
            <>
              <FaEdit className="text-lg" /> Edit CV
            </>
          )}
        </button>

        {/* Header Section */}
        <div className="border-b border-orange-200 pb-4">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
            <div>
              {isEditing ? (
                <div className="flex flex-col sm:flex-row gap-3">
                  <input
                    type="text"
                    value={editableData.personalInfo.firstName}
                    onChange={(e) => handlePersonalChange('firstName', e.target.value)}
                    className="text-2xl sm:text-3xl font-bold text-orange-800 bg-white border border-orange-300 rounded-lg px-3 py-2 focus:outline-none focus:border-orange-500 w-full sm:w-auto"
                    placeholder="First Name"
                  />
                  <input
                    type="text"
                    value={editableData.personalInfo.lastName}
                    onChange={(e) => handlePersonalChange('lastName', e.target.value)}
                    className="text-2xl sm:text-3xl font-bold text-orange-800 bg-white border border-orange-300 rounded-lg px-3 py-2 focus:outline-none focus:border-orange-500 w-full sm:w-auto"
                    placeholder="Last Name"
                  />
                </div>
              ) : (
                <h1 className="text-2xl sm:text-3xl font-bold text-orange-800 leading-tight">
                  {`${editableData.personalInfo.firstName} ${editableData.personalInfo.lastName}`}
                </h1>
              )}
              <p className="text-orange-600 mt-1 text-sm sm:text-base">Professional CV</p>
            </div>

            {/* <div className="text-left sm:text-right">
              <button className="px-4 py-2 rounded-lg bg-orange-600 text-white hover:bg-orange-700 transition-colors text-sm whitespace-nowrap">
                e-verify log
              </button>
              <p className="text-xs sm:text-sm text-orange-600 mt-2">Verified Professional Profile</p>
            </div> */}
          </div>
        </div>

        {/* Personal Information Section */}
        <div className="mt-8">
          <div className="flex items-center gap-2 mb-4">
            <FaUser className="text-orange-600 flex-shrink-0" />
            <h2 className="text-lg sm:text-xl font-semibold text-gray-800">Personal Information</h2>
          </div>
          <div className="bg-white rounded-lg p-4 sm:p-6 shadow-sm">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <CvInfo 
                title="Date of Birth" 
                data={isEditing ? (
                  <input
                    type="text"
                    value={editableData.personalInfo.dateOfBirth}
                    onChange={(e) => handlePersonalChange('dateOfBirth', e.target.value)}
                    className="w-full bg-transparent border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-orange-500"
                  />
                ) : editableData.personalInfo.dateOfBirth}
              />
              <CvInfo 
                title="Email" 
                data={isEditing ? (
                  <input
                    type="email"
                    value={editableData.personalInfo.email}
                    onChange={(e) => handlePersonalChange('email', e.target.value)}
                    className="w-full bg-transparent border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-orange-500"
                  />
                ) : editableData.personalInfo.email}
              />
              <CvInfo 
                title="Address" 
                data={isEditing ? (
                  <input
                    type="text"
                    value={editableData.personalInfo.address}
                    onChange={(e) => handlePersonalChange('address', e.target.value)}
                    className="w-full bg-transparent border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-orange-500"
                  />
                ) : editableData.personalInfo.address}
              />
            </div>
          </div>
        </div>

        {/* Education Section */}
        <div className="mt-8">
          <div className="flex items-center gap-2 mb-4">
            <FaGraduationCap className="text-orange-600 flex-shrink-0" />
            <h2 className="text-lg sm:text-xl font-semibold text-gray-800">Education Background</h2>
          </div>
          <div className="space-y-4">
            {editableData.education.map((eachEducation, index) => (
              <div key={index} className="bg-white rounded-lg p-4 sm:p-6 shadow-sm">
                <CvEducation
                  school={isEditing ? (
                    <input
                      type="text"
                      value={eachEducation.school || ''}
                      onChange={(e) => handleArrayChange('education', index, 'school', e.target.value)}
                      className="w-full bg-transparent border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-orange-500"
                    />
                  ) : eachEducation.school}
                  course={isEditing ? (
                    <input
                      type="text"
                      value={eachEducation.course || ''}
                      onChange={(e) => handleArrayChange('education', index, 'course', e.target.value)}
                      className="w-full bg-transparent border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-orange-500"
                    />
                  ) : eachEducation.course}
                  year={isEditing ? (
                    <input
                      type="text"
                      value={`${eachEducation.startYear || ''} - ${eachEducation.finishYear || ''}`}
                      onChange={(e) => {
                        const parts = e.target.value.split('-').map(p => p.trim());
                        handleArrayChange('education', index, 'startYear', parts[0] || '');
                        handleArrayChange('education', index, 'finishYear', parts[1] || '');
                      }}
                      className="w-full bg-transparent border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-orange-500"
                    />
                  ) : `${eachEducation.startYear} - ${eachEducation.finishYear}`}
                />
              </div>
            ))}
          </div>
        </div>

        {/* Work Experience Section */}
        <div className="mt-8">
          <div className="flex items-center gap-2 mb-4">
            <FaBriefcase className="text-orange-600 flex-shrink-0" />
            <h2 className="text-lg sm:text-xl font-semibold text-gray-800">Work Experience</h2>
          </div>
          <div className="space-y-4">
            {editableData.experience.map((eachExperience, index) => (
              <div key={index} className="bg-white rounded-lg p-4 sm:p-6 shadow-sm">
                <CvWorkExperience
                  title={isEditing ? (
                    <input
                      type="text"
                      value={eachExperience.positionHeld || ''}
                      onChange={(e) => handleArrayChange('experience', index, 'positionHeld', e.target.value)}
                      className="w-full bg-transparent border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-orange-500"
                    />
                  ) : eachExperience.positionHeld}
                  companyName={isEditing ? (
                    <input
                      type="text"
                      value={eachExperience.companyName || ''}
                      onChange={(e) => handleArrayChange('experience', index, 'companyName', e.target.value)}
                      className="w-full bg-transparent border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-orange-500"
                    />
                  ) : eachExperience.companyName}
                  year={isEditing ? (
                    <input
                      type="text"
                      value={`${eachExperience.startYear || ''} - ${eachExperience.finishYear || ''}`}
                      onChange={(e) => {
                        const parts = e.target.value.split('-').map(p => p.trim());
                        handleArrayChange('experience', index, 'startYear', parts[0] || '');
                        handleArrayChange('experience', index, 'finishYear', parts[1] || '');
                      }}
                      className="w-full bg-transparent border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-orange-500"
                    />
                  ) : `${eachExperience.startYear} - ${eachExperience.finishYear}`}
                  jobDescription={isEditing ? (
                    <textarea
                      value={eachExperience.jobDescription || ''}
                      onChange={(e) => handleArrayChange('experience', index, 'jobDescription', e.target.value)}
                      className="w-full bg-transparent border border-gray-300 rounded-md px-3 py-3 focus:outline-none focus:border-orange-500 min-h-[80px] resize-y"
                    />
                  ) : eachExperience.jobDescription}
                />
              </div>
            ))}
          </div>
        </div>

        {/* Certificates Section */}
        <div className="mt-8">
          <div className="flex items-center gap-2 mb-4">
            <FaCertificate className="text-orange-600 flex-shrink-0" />
            <h2 className="text-lg sm:text-xl font-semibold text-gray-800">Certificates</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {editableData.certificate.map((eachCertificate, index) => (
              <div key={index} className="bg-white rounded-lg p-4 sm:p-6 shadow-sm">
                <CvCertificate
                  title={isEditing ? (
                    <input
                      type="text"
                      value={eachCertificate.certificateName || ''}
                      onChange={(e) => handleArrayChange('certificate', index, 'certificateName', e.target.value)}
                      className="w-full bg-transparent border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-orange-500"
                    />
                  ) : eachCertificate.certificateName}
                  year={isEditing ? (
                    <input
                      type="text"
                      value={eachCertificate.issueDate || ''}
                      onChange={(e) => handleArrayChange('certificate', index, 'issueDate', e.target.value)}
                      className="w-full bg-transparent border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-orange-500"
                    />
                  ) : eachCertificate.issueDate}
                  serialNumber={isEditing ? (
                    <input
                      type="text"
                      value={eachCertificate.serialNumber || ''}
                      onChange={(e) => handleArrayChange('certificate', index, 'serialNumber', e.target.value)}
                      className="w-full bg-transparent border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-orange-500"
                    />
                  ) : eachCertificate.serialNumber}
                  issueDate={isEditing ? (
                    <input
                      type="text"
                      value={eachCertificate.issueDate || ''}
                      onChange={(e) => handleArrayChange('certificate', index, 'issueDate', e.target.value)}
                      className="w-full bg-transparent border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-orange-500"
                    />
                  ) : eachCertificate.issueDate}
                />
              </div>
            ))}
          </div>
        </div>

        {/* Guarantor Section */}
        <div className="mt-8">
          <div className="flex items-center gap-2 mb-4">
            <FaUserShield className="text-orange-600 flex-shrink-0" />
            <h2 className="text-lg sm:text-xl font-semibold text-gray-800">Guarantor</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {editableData.guarantor.map((eachGuarantor, index) => (
              <div key={index} className="bg-white rounded-lg p-4 sm:p-6 shadow-sm">
                <CvGuarantor
                  guarantorName={isEditing ? (
                    <input
                      type="text"
                      value={eachGuarantor.name || ''}
                      onChange={(e) => handleArrayChange('guarantor', index, 'name', e.target.value)}
                      className="w-full bg-transparent border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-orange-500"
                    />
                  ) : eachGuarantor.name}
                  phoneNumber={isEditing ? (
                    <input
                      type="text"
                      value={eachGuarantor.phone || ''}
                      onChange={(e) => handleArrayChange('guarantor', index, 'phone', e.target.value)}
                      className="w-full bg-transparent border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:border-orange-500"
                    />
                  ) : eachGuarantor.phone}
                />
              </div>
            ))}
          </div>
        </div>

      </div>
    </PDFGenerator>
  );
}

export default CvTemplate1;